import $ from "jquery";
import uly from "ulysses/core";
import HalResource from "ulysses/api";


export function choose_template(entity, engine) {
    var def = Promise.Deferred();
    var dialog_markup = $("#pick-template-dialog").html();
    var filters = [];
    if (engine) {
        filters.push(`channels * '${engine}'`);
    }
    let theme = uly.page.userprofile.theme();
    if (theme) {
        filters.push(`((((themes='${theme}') or (themes =~ ',${theme}')) or (themes ~= '${theme},')) or (themes='null')) or (themes * ',${theme},')`);
    }

    let filter = null;
    filters.forEach((f) => {
        if (filter === null) {
            filter = f;
        } else {
            filter = `(${f}) and (${filter})`;
        }
    });

    uly.api.start().follow("uly:data").follow("uly:documenttemplate", {
        "filters": filter,
        "entity": entity ? entity.type_name : null
    }).follow("uly:grid", {
        "view": "embedded"
    }).then((result) => {
        var hal_grid = HalResource(result);
        hal_grid.follow("uly:datatable").then(function (grid_data) {
            if (!(grid_data.data && grid_data.data.length)) {
                def.resolve(null);
                return;
            } else if (grid_data.data.length === 1) {
                def.resolve(grid_data.data[0].id);
                return;
            }
            var dialog_data = {
                "grid": result,
                "select_row": function (_ev, $elt, ui) {
                    var template_id = null;
                    if (ui && ui.entity_model && ui.entity_model.id) {
                        template_id = ui.entity_model.id;
                    }
                    $elt.trigger("action:closedialog", {
                        "context": {
                            "$parent": {
                                "dialog_data": template_id
                            }
                        }
                    });
                }
            };
            uly.dialogs.execute(dialog_markup, {
                "title": _("communications_title_select_message_template", "Select Message Template")
            }, dialog_data).then(function ([result]) {
                def.resolve(result);
            }, def.reject);
        }, def.reject);
    }, def.reject);
    return def;
};

